import { Box, Divider, FormLabel, Tag } from "@chakra-ui/react";
import { ColumnDef } from "@tanstack/react-table";
import ActiveTag from "components/ui/ActiveTag";
import ButtonCreateNew from "components/ui/ButtonCreateNew";
import CheckboxSelect from "components/ui/CheckboxSelect/CheckboxSelect";
import FilterGroup from "components/ui/FilterGroup";
import HeaderBar from "components/ui/HeaderBar";
import SearchInput from "components/ui/SearchInput";
import DynamicTableProvider, {
  useDynamicTableContext,
} from "contexts/DynamicTableContext";
import LayoutParameters from "features/auth/layouts/LayoutParameters";
import React from "react";
import ThemesList from "../components/ThemesList";

enum LANGUAGE {
  PT_BR = "Português",
  EN = "Inglês",
}

export const LANGUAGE_COLORS = {
  PT_BR: "blue",
  EN: "purple",
};

export default function PageThemes() {
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        header: "Nome",
        accessorKey: "name",
      },
      {
        header: "Idioma",
        accessorKey: "language",
        cell: ({ row }) => (
          <Tag
            colorScheme={
              LANGUAGE_COLORS[row.original.language as keyof typeof LANGUAGE]
            }
          >
            {LANGUAGE[row.original.language as keyof typeof LANGUAGE]}
          </Tag>
        ),
        filterFn: "arrIncludesSome",
      },
      {
        header: "Status",
        accessorKey: "active",
        cell: ({ row }) => <ActiveTag isActive={row.original.active} />,
      },
    ],
    []
  );
  return (
    <LayoutParameters>
      <DynamicTableProvider
        columns={columns}
        resource={{
          resourceName: "contentParameters",
          path: "/content-parameters",
          params: { type: "THEME" },
        }}
        tableOptions={{
          enableGlobalFilter: false,
        }}
      >
        <HeaderBar
          title="Report → Temas"
          description="Visualize a lista de temas Patri"
          px="0"
          sx={{
            h1: {
              mt: "0",
            },
          }}
        >
          <ButtonCreateNew title="Cadastrar novo" to="/temas/novo" />
        </HeaderBar>

        <Divider />

        <Box pt="24px">
          <Filters />
          <ThemesList />
        </Box>
      </DynamicTableProvider>
    </LayoutParameters>
  );
}

function Filters() {
  const { table } = useDynamicTableContext();

  return (
    <FilterGroup justifyContent="space-between" pos="relative">
      <Box flex={1} minW="180px">
        <FormLabel>Buscar</FormLabel>
        <SearchInput
          placeholder="Buscar por nome"
          onChange={(value) =>
            table.getColumn("name")?.setFilterValue(String(value))
          }
        />
      </Box>
      <Box>
        <FormLabel>Filtrar por idioma</FormLabel>
        <CheckboxSelect
          placeholder="Todos os idiomas"
          options={Object.entries(LANGUAGE).map(([key, value]) => ({
            value: key,
            label: value,
          }))}
          onChange={(value) =>
            table
              .getColumn("language")
              ?.setFilterValue(value.map((v) => v.value))
          }
        />
      </Box>
    </FilterGroup>
  );
}
